export enum AppEventAction {
  BagsDroppedOff = 'bagsDroppedOff',
  BagsPickedUp = 'bagsPickedUp',
  BookingCanceled = 'bookingCanceled',
  BookingCreated = 'bookingCreated',
  IncidentReported = 'incidentReported',
  PageView = 'pageView',
  PaymentMethodAdded = 'paymentMethodAdded',
  SignIn = 'signIn',
  SignUp = 'signUp',
}

export const SERVER_TRACKED_ACTIONS: string[] = [
  AppEventAction.BagsDroppedOff,
  AppEventAction.BagsPickedUp,
  AppEventAction.BookingCanceled,
  AppEventAction.BookingCreated,
  AppEventAction.IncidentReported,
  AppEventAction.PaymentMethodAdded,
  AppEventAction.SignUp,
];

export enum AppPlatform {
  Web = 'Web',
  iOS = 'iOS',
  Android = 'Android',
}

export interface AppEvent {
  category?: string;
  label?: string;
  value?: number;
  currency?: string;
  orderId?: string;
  appPlatform?: AppPlatform;
  appVersion?: string;
  geoLocation?: {
    lat: number;
    lon: number;
  };
}
